import { useParams } from 'react-router-dom';
import { usePokerHand } from '../context/hands-api';

// TODO: This is only for viewing hands when having link, make it use HandTable
const Viewer = ({ pokerHand: pokerHandProp }) => {
  const { userId, pokerHandId } = useParams();
  const { pokerHand, loading } = usePokerHand(userId, pokerHandId);
  const data = pokerHandProp || pokerHand;

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  return (
    <div>
      <h4>Actions:</h4>
      {data.actions?.preflop?.map((action) => (
        <div style={{ border: 1 }} key={action.id}>
          <p>{action.player} {action.type} {action.amount}</p>
        </div>
      ))}
    </div>
  );
};

export default Viewer;
